import fetch from './fetch'

export const _login = p => fetch.post('/user/login', p)
export const _test = p => fetch.get('/test', p)
export const _getDataMap = p => fetch.post('/bp/getDataMap', p)
export const _uploadEye = p => fetch.post('/bp/upload', p, { loading: false })
export const _authentication = p => fetch.get('/ding/getJsapiAuth', p, { loading: false })
export const _legalFromApply = p => fetch.post('/legal/aid/apply', p, { loading: true })
export const _adviceFromApply = p => fetch.post('/advice/plan/submit', p, { loading: true })
export const _getHistoryAdviceList = p => fetch.get('/advice/plan/getHistory', p, { loading: false })
export const _getAdviceDetail = p => fetch.get('/advice/plan/getDetail', p, { loading: false })
export const _submitPsychological = p => fetch.post('/psychological/counseling/submit', p, { loading: true })
export const _getPsychologicalRecord = p => fetch.get('/psychological/counseling/getRecord', p, { loading: false })
export const _getPsychologicalDetail = p => fetch.get('/psychological/counseling/getDetail', p, { loading: true })
// 是否需要api授权
export const _getIsNeedAuth = p => fetch.get('/ding/isNeedAuthorizeApi', p, { loading: false })
// 提交授权成功
export const _submitAuthSuccess = p => fetch.get('/ding/authorizeApiSuccess', p, { loading: false })
// 是否需要展示礼包
export const _getCanGetGift = p => fetch.get('/choose/gift/pack/canGetGift', p, { loading: false })
// 地区列表集合
export const _getArea = p => fetch.post('/area/areaList', p, { loading: false })
// 领取礼包
export const _submitPickGift = p => fetch.post('/choose/gift/pack/get', p, { loading: false })
// 查询是否领取
export const _checkGiftPack = p => fetch.get('/choose/gift/pack/hasGiftInfo', p, { loading: true })
// 查询是否领取
export const _authAlipay = p => fetch.get('/corpCode/biz/login', p, { loading: false })

export default null
